<template lang="html">
  <Row>
    <Col span="24">
      <Row type="flex" justify="center" class="plat-title">
        <h1 style="font-size: 28px; text-align: center">Cutting-Edge Tools For Managing Your Finances</h1>          
      </Row>
      <Row type="flex" justify="center" class="">
          <h3 style="font-size: 1rem; max-width: 600px; text-align: center; padding: 16px; padding-top: 0;">
            Use our powerful suite of software to <strong>visualize your entire portfolio</strong> in one place, and <strong>track key performance metrics</strong> effortlessly.
          </h3>
      </Row>
      <Row type="flex" justify="center" class="plat-card-list">
        <Col class="plat-card-container" v-for="item in list" :key="item.title">
          <router-link :to="{ name: item.route }">
            <Card class="plat-card lift-on-hover">
            <!-- <Card class="plat-card" :style="{ background: item.color, color: '#fff' }"> -->
              <Row type="flex" justify="center" style="padding-top: 8px; padding-bottom: 16px;">
                <Icon :type="item.icon" :color="item.color" :size="40"></Icon>
                <!-- <Icon :type="item.icon" color="#fff" :size="40"></Icon> -->
              </Row>
              <Row type="flex" justify="center" align="middle">
                <h2>{{ item.card.title }}</h2>
              </Row>
              <Row type="flex" justify="start" class="plat-card-description">{{ item.card.description }}</Row>
              <Row type="flex" justify="center" align="middle">
                <Button type="primary" long>Learn More <Icon type="arrow-right-c"></Icon></Button>              
              </Row>
            </Card>
          </router-link>
        </Col>
      </Row>
    </Col>
  </Row>
</template>
<script>
import platformComponents from '../services/platformComponents';

export default {
  data() {
    return { list: platformComponents };
  },
};
</script>
<style lang="css" scoped>
  .plat-title {
    padding: 16px;
    padding-top: 64px;
  }

  .plat-card-list {
    padding-top: 48px;
    padding-bottom: 96px;
  }

  .plat-card {
    height: 286px;
    width: 320px;
    padding: 16px;
    color: rgba(0,0,0,0.7);
  }

  .plat-card-container {
    min-height: 286px;
    width: 320px;
    margin: 16px;
    color: rgba(0,0,0,0.7);
  }

  .plat-card-description {
    padding-top: 16px;
    min-height: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/PlatformComponentsList.vue